export const EMPTY_RESULTS = ['', ''] as [string, string];
